export default function LandingPage() {
  return (
    <div>
      <h1>Landing page งับ</h1>
    </div>
  );
}
